import './item.less';
import PropTypes from 'prop-types';
import React from 'react';
import Select from '../../../shared/form-elements/select/select';
import cn from 'classname';
import Calendar from '../../../shared/calendar/main';
import find from 'lodash/find';

const propTypes = {
	overflow: PropTypes.array,
	placeholder: PropTypes.string,
	options: PropTypes.any,
	searchable: PropTypes.bool,
	multi: PropTypes.bool,
	name: PropTypes.string,
	shouldOpenOptionsByName: PropTypes.string,
	value: PropTypes.array,
	uri: PropTypes.string,
	shouldInverse: PropTypes.bool,
	shouldShowInverseControl: PropTypes.bool,
	onAddValue: PropTypes.func,
	onDeleteValue: PropTypes.func,
	onDeleteItem: PropTypes.func,
	onClearValue: PropTypes.func,
	onLoadOptions: PropTypes.func,
	onToggleInverse: PropTypes.func,
	onCloseOptions: PropTypes.func,
	onBlockFilter: PropTypes.func,
	isBlocked: PropTypes.bool,
	intl: PropTypes.func,
	calendarSignUpAffiliate: PropTypes.object,
	calendarSignUpAffiliateInit: PropTypes.func,
	calendarSignUpAffiliateToggle: PropTypes.func,
	calendarSignUpAffiliateChange: PropTypes.func,
	calendarSignUpAffiliateApply: PropTypes.func,
	selectedFilters: PropTypes.array
};

const Item = props => (
	<div className="filter__item filters__left">
		<div className={cn({
			'filter__item-select': true,
			'form-element-select': true,
			'is-exclude': props.shouldInverse
		})}>
			<Select
				placeholder={props.intl(props.placeholder)}
				value={props.value}
				options={props.onLoadOptions(props.options)}
				searchable={props.searchable}
				multi={props.multi}
				name={props.name}
				isOpenAfterSelection={props.isOpenAfterSelection}
				isFilterSelect={true}
				shouldOpenOptions={props.shouldOpenOptionsByName === props.name}
				onClose={name => props.onCloseOptions(name)}
				onChange={value => props.onAddValue(value, props.name)}
				isBlockedFilter={props.isBlocked}
			/>
			{
				props.name === 'affiliateRegistrationDate' ?
					<div className={
						(defineIndexOfSignUpFilter(props.selectedFilters, 'affiliateRegistrationDate') < 2) ?
							'calendar-container calendar-position-right' : 'calendar-container'
					}
					>
						<Calendar
							{...props.calendarSignUpAffiliate}
							onInit={props.calendarSignUpAffiliateInit}
							onToggle={props.calendarSignUpAffiliateToggle}
							onChange={props.calendarSignUpAffiliateChange}
							onApply={props.calendarSignUpAffiliateApply}
							intl={props.intl}
						/>
					</div>
					:
					null
			}
		</div>
		{!!props.value.length && (
			<div className={cn({
				'filter__item-values': true,
				'is-exclude': props.shouldInverse
			})}>
				{renderValue(props)}
			</div>
		)}

		{!!props.value.length && (
			<div className="filter__item-controls position-bottom">
				{props.shouldShowInverseControl && (
					<span
						className="control exclude"
						onClick={() => props.onToggleInverse(props.name)}>{props.intl('Exclude')}</span>
				)}
				<span
					className="control delete"
					onClick={() => props.onClearValue(props.name)}>{props.intl('Clear')}</span>
			</div>
		)}
	</div>
);

function renderValue(props) {
	if (props.overflow) {
		const { max } = find(props.overflow, o => o.name === props.name) || {};

		if (max && props.value.length > max) {
			return (
				<span className="item">
					<span className="item__value">
						more than {max}
					</span>
				</span>
			);
		}
	}

	return props.value.map(item => (
		<span className="item" key={item.value}>
			<span className="item__value">
				{item.label}
			</span>
			<span
				className="item__close"
				onClick={() => props.onDeleteValue(item, props.name)}
			/>
		</span>
	));
}

const defineIndexOfSignUpFilter = (selectedFilters, filterName) => {
	let index = -1;

	selectedFilters.forEach((item, count) => {
		if (item.name === filterName) {
			index = count;
			return;
		}
	});
	return index;
};

Item.propTypes = propTypes;

export default Item;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/fixed-filters/components/item.js